import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign } from 'lucide-react';

export default function FinancialControl() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Financial Control</h1>
        <p className="text-[#8A93A6]">Revenue tracking, payouts, and financial oversight</p>
      </div>
      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2 text-white">
            <DollarSign className="h-5 w-5 text-green-500" />
            Financial Dashboard
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#8A93A6]">Revenue metrics, payout management, and financial controls will be available here.</p>
        </CardContent>
      </Card>
    </div>
  );
}
